import { render, staticRenderFns } from "./TabList.vue?vue&type=template&id=95965bd0&scoped=true&"
import script from "./TabList.vue?vue&type=script&lang=js&"
export * from "./TabList.vue?vue&type=script&lang=js&"
import style0 from "./TabList.vue?vue&type=style&index=0&id=95965bd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95965bd0",
  null
  
)

export default component.exports